import axios from 'axios';
import { stripNonNumeric } from '../helpers/StringHelpers';

export default {
    expressOptimizedPaintlistForProduct(productId, optimizedpaintlistID) {
        let payload = { productId };

        if (optimizedpaintlistID) {
            payload.optimizedpaintlistID = optimizedpaintlistID;
        }

        return axios.post(
            '/sawline/expressOptimizedPaintlistForProduct/',
            payload
        );
    },
    fetchErrorDebugData() {
        return axios.post('/sawline/fetchErrorDebugData/');
    },
    errorReport(
        optimizedpaintlistID,
        sawlineIds,
        optimizedpaintlistrecordID,
        selectedOption,
        employeeId
    ) {
        const payload = {
            optimizedpaintlistID,
            sawlineIds,
            optimizedpaintlistrecordID,
            selectedOption,
            employeeId,
        };

        return axios.post('/sawline/errorReport/', payload);
    },
    fetchSawlines(productId, withChildSawlines = false) {
        return axios.post('/sawline/fetchSawlines/', {
            productId,
            withChildSawlines,
        });
    },
    fetchEditOptions() {
        return axios.post('/sawline/fetchEditOptions/');
    },
};
